// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"af3109ae","283":"d40c5f11","686":"38b490db"}[chunkId] + ".chunk.js";
};